import { useForm } from "react-hook-form";
import Input from "../../Components/CommonCommponents/Input";
import { useEffect, useState } from "react";
import { useRef } from "react";
import toast from "react-hot-toast";
import FooterLayout from "../../Components/FooterLayout";
import groupIcon from "../../Assets/Icons/Group1.png";
import Select from "../../Components/CommonCommponents/select/Select";
import AuthService from "../../Service.js/authService";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import DatePicker from "../../Components/CommonCommponents/DatePicker";
import {
  dateConverter,
  removeCodeFromNumber,
} from "../../Components/Utilities/util";
import TextArea from "../../Components/CommonCommponents/TextArea";
import CandidateLogin from "../CandidateLogin";
import {
  BrowserRouter as Router,
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useParams } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { isEmpty } from "lodash";
import dayjs from "dayjs";
import Config from "../../Service.js/config";
import authHeader from "../../Service.js/authHeader";
import { message, Upload, Modal, Checkbox, Button } from "antd";
import FileViewer from "react-file-viewer";
import uploadIcon from "../../Assets/Icons/uploadgroup.svg";
import termsDoc from "../../Assets/docs/terms_and_conditions.docx";
import useLayoutStore from "../../store/LayoutStore";
import ProfileConfrmation from "./ProfileConfirmation";
import OtpVerification from "./OtpVerification";
import { Flex, Progress, Spin } from "antd";
// import layerimage from "././../../Assets/Icons/layer.jpeg";
import layerimage from "././../../Assets/Icons/layer-bg.png";
import { IoArrowBackSharp } from "react-icons/io5";

const CandidateRegister = () => {
  const { Dragger } = Upload;
  const navigate = useNavigate();
  const hiddenFileInput = useRef(null);
  const [fileName, setFileName] = useState();
  const [educationData, setEducationData] = useState();
  const [skillData, setSkillData] = useState();
  const [isActiveFile, setActiveFile] = useState(false);
  const [isCountryLayout, setCountryLayout] = useState(false);
  const [phoneCode, setPhonecode] = useState();
  const [skillSearch, setSkillSearch] = useState();
  const [educationSearch, setEducationSerach] = useState();
  const [open, setOpen] = useState(false);
  const [candidateToken, setCandidateToken] = useState();
  const [locations, setLocations] = useState();
  const [selectedFile, setSelectedFile] = useState(null);
  const [isSignup, setSignUp] = useState(true);
  const [isConfirm, setIsConfirm] = useState(false);
  const [extractedDetails, setExtractedDetails] = useState();
  const [isVerifyOtp, setIsVerifyOtp] = useState(false);
  const [isProgress, setProgress] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);

  const handleAcceptTerms = () => {
    setIsTermsAccepted(true);
    setIsTermsModalOpen(false);
  };
  const currentUser = JSON.parse(localStorage.getItem("candidate"));
  const [logo, setLogo] = useState();
  const params = useParams();
  const { setSingupResponse, createdSignupResponse } = useLayoutStore(
    (state) => ({
      createdSignupResponse: state.createdSignupResponse,
      setSingupResponse: state.setSingupResponse,
    })
  );
  const {
    register,
    control,
    setError,
    setValue,
    reset,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const props = {
    name: "resume",
    accept: ".doc,.docx,.rtf,.pdf",
    multiple: false, // Assuming single file upload for resume
    authHeader: false,
    showUploadList: false,
    beforeUpload: (file) => {
      // Prevent automatic upload
      setSelectedFile(file);
      return false; // Prevent default upload action
    },
    onChange(info) {
      // When file is removed
      if (info?.fileList?.length === 0) {
        setSelectedFile(null);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
      if (e.dataTransfer.files.length > 0) {
        setSelectedFile(e.dataTransfer.files[0]); // Save the dragged file locally
      }
    },
    // onChange(info) {
    //   const { status } = info.file;
    //   if (status !== "uploading") {
    //     console.log(info.file, info.fileList);
    //   }
    //   if (status === "done" || status === "error") {
    //     setSelectedFile(info.file.originFileObj); // Save the selected file locally
    //     //message.success(`${info.file.name} file selected successfully`);
    //   }
    // },
    // showUploadList: {
    //   showDownloadIcon: true,
    //   downloadIcon: "Download",
    //   showRemoveIcon: true,
    // },
  };
  console.log("errors", selectedFile);
  useEffect(() => {
    if (isEmpty(params)) return;
    const token = params?.candidateId;
    const decoded = jwtDecode(token);
    setCandidateToken(decoded);
    getCandidateDEtails(decoded);
  }, [params]);

  console.log("testcide", candidateToken);
  const getCandidateDEtails = async (token) => {
    await AuthService.candidateDetails(token)
      .then((response) => {
        console.log("responses", response.data.data);
        getData(response.data.data);
      })
      .catch((error) => {});
  };
  const job = watch("job");
  const getData = (data) => {
    const skills = data.skills.map((obj) => {
      return {
        value: obj.option_id,
        label: obj.option_value,
      };
    });
    const qualifications = data.qualifications.map((obj) => {
      return {
        value: obj.option_id,
        label: obj.option_value,
      };
    });

    const location = {
      value: data?.location,
      label: data?.location,
    };

    setValue("locations", location);
    setValue("first_name", data?.candidate_credentials.first_name);
    setValue("last_name", data?.candidate_credentials.last_name);
    setValue("email", data?.candidate_credentials.email);
    const phn_number = removeCodeFromNumber(
      data?.candidate_credentials.mobile_number
    );
    if (phn_number) {
      setCountryLayout(true);
    }
    setValue("mobile_number", phn_number);
    setValue("total_exp", data?.total_exp);
    setValue("current_ctc", data?.current_ctc);
    setValue("notice_period", data?.notice_period);
    setValue("skills", skills);
    setValue("qualifications", qualifications);
    setValue("current_location", data.current_location);
    setValue("dob", data.dob ? dayjs(data.dob) : "");
    setValue("application_username", data.application_username);
  };

  const fileSizeValidation = (file) => {
    if (file[0]?.size > 2000000) {
      toast.error("File size should be 2MB or less!!");
    }
  };

  const handelInputChange = (onChange, e) => {
    onChange(e);
    if (e.target.value !== "") {
      var test = Number(e.target.value);
      var test1 = Number.isInteger(test);
      if (test1) {
        setCountryLayout(true);
        setPhonecode("+91");
      } else {
        setCountryLayout(false);
        setPhonecode("");
      }
    } else {
      setCountryLayout(false);
      setPhonecode("");
    }
  };

  const handelChangePhone = (e) => {
    var value = `+${e}`;
    setPhonecode(value);
  };

  const handleFile = (e) => {
    console.log("tedte", e.target.files[0]);
    setFileName(e.target.files[0]);
    // setUpladedImage(URL.createObjectURL(e.target.files[0]));
    setActiveFile(true);
    //logoOnChange(e)
    setValue("logo", e.target.files[0]);
    console.log("asdasd");
  };
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleSkillSearch = async (value) => {
    console.log("value", value);
    setSkillSearch(value);
    await AuthService.skillsDetails(skillSearch)
      .then((response) => {
        setSkillData(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleEducationsearch = async (value) => {
    setEducationSerach(value);
    await AuthService.educationDetails(educationSearch)
      .then((response) => {
        setEducationData(response.data.data);
        //setSkills(response.data.data.skills)
        //setLocation(response.data.data.location)
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleLocations = async (serachValue) => {
    await AuthService.getLocations(serachValue)
      .then((response) => {
        setLocations(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const onClose = () => {
    setOpen(false);
  };
  const resumeUpload = async () => {
    await AuthService.resumeUpload(fileName)
      .then((response) => {
        if (response.data.success == true) {
          toast.success("Sucessfully Registered");
          setOpen(true);
        }
      })
      .catch((error) => {
        console.log("error", error);
        toast.error("Failed To Register");
      });

    // navigate("/");
  };
  const createProfile = async (data) => {
    if (isCountryLayout) {
      data["mobile_number"] = phoneCode + data.mobile_number;
    }

    // const date = dateConverter(data.dob);
    // const dob = date.convertedValue;
    // const dob = dayjs(data.dob).format("YYYY-MM-DD");
    // const optionskills = data.skills.map((i) => i.value);
    // const optionEducations = data.qualifications.map((i) => i.value);
    // var arrayOptions = {
    //   skills: optionskills,
    //   qualifications: optionEducations,
    //   total_exp: data.total_exp ? Number(data.total_exp) : "",
    // };

    let candidate_city = null;
    let candidate_state = null;
    let candidate_country = null;
    // if (data?.locations?.value) {
    //   const string = data?.locations?.value?.split(",");
    //   candidate_city = string[0];
    //   candidate_state = string[1];
    //   candidate_country = string[2];
    // }
    // data["candidate_city"] = candidate_city;
    // data["candidate_state"] = candidate_state;
    // data["candidate_country"] = candidate_country;
    console.log("datadata", data);
    await AuthService.candidateRegistrationServie(
      data,
      // arrayOptions,
      fileName
      // dob
    )
      .then(
        async (response) => {
          console.log("response", response.data.success);
          if (response.data.success == true) {
            if (fileName) {
              resumeUpload();
            } else {
              toast.success("Sucessfully Registered");
              setOpen(true);
            }
          }
        },
        (error) => {
          const errorsObj = error.response.data.error_info;
          Object.keys(errorsObj).forEach((field) => {
            const messages = errorsObj[field];
            setError(field, {
              type: "server",
              message: messages.join(". "),
            });
          });
        }
      )
      .catch((error) => {
        console.log("error", error);
        toast.error("Failed To Register");
      });
  };
  const handleSignup = async () => {
    console.log("testfile", selectedFile);
    if (selectedFile == null) {
      toast.error("Please Upload your Resume");
    } else {
      setProgress(true);
      await AuthService.signupResumeUpload(selectedFile)
        .then((response) => {
          if (response.data.success == true) {
            setProgress(false);
            setExtractedDetails(response.data.data);
            //toast.success("Sucessfully Registered");
            setSignUp(false);
            setIsConfirm(true);
            //navigate("/profileConfirmation");
          }
        })
        .catch((error) => {
          console.log("error", error);
          toast.error("Failed To Register");
        });
    }
  };
  console.log("createdSignupResponse", createdSignupResponse);

  const updateProfile = async (data) => {
    console.log("testlog", data);
    const mobile_number = `+91${data.mobile_number}`;
    // const dob = dayjs(data.dob).format("YYYY-MM-DD");
    // const optionskills = data.skills.map((i) => i.value);
    // const optionEducations = data.qualifications.map((i) => i.value);
    var arrayOptions = {
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email,
      mobile_number: mobile_number,
      application_username: data.application_username,
    };

    // let candidate_city = null;
    // let candidate_state = null;
    // let candidate_country = null;
    // if (data?.locations?.value) {
    //   const string = data?.locations?.value?.split(",");
    //   candidate_city = string[0];
    //   candidate_state = string[1];
    //   candidate_country = string[2];
    // }
    // data["candidate_city"] = candidate_city;
    // data["candidate_state"] = candidate_state;
    // data["candidate_country"] = candidate_country;
    // console.log(dob, "dobdobdobdob");
    // console.log(data, "dobdobdobdob");
    await AuthService.updateCandidateRegistration(
      data,
      candidateToken,
      fileName,
      arrayOptions
      // optionskills,
      // optionEducations,
      //dob
    )
      .then(
        (response) => {
          if (response.data.success == true) {
            if (fileName) {
              resumeUpload();
            } else {
              toast.success("Sucessfully Registered");
              setOpen(true);
            }
          }
        },
        (error) => {
          const errorsObj = error.response.data.error_info;
          console.log(errorsObj, "errorsObj");
          Object.keys(errorsObj).forEach((field) => {
            const messages = errorsObj[field];
            setError(field, {
              type: "server",
              message: messages.join(". "),
            });
          });
        }
      )
      .catch((error) => {
        toast.error("Failed To Update");
      });
  };
  const onSubmit = async (data) => {
    // if (isEmpty(candidateToken)){
    //     createProfile(data)
    // }

    if (candidateToken?.candidate) {
      updateProfile(data);
    } else {
      createProfile(data);
    }
  };

  const getLogo = async () => {
    if (currentUser) {
      await AuthService.getCompanyLogoWithLogin()
        .then((oResponse) => {
          console.log("oResponse", oResponse.data.data);
          setLogo(oResponse.data.data);
          //setSingleSelectValue({...singleSelectValue, [id]:dropDownOPtions(oResponse.data.data.prescreen_fields)})
        })
        .catch((err) => err);
    } else {
      await AuthService.getCompanyLogoWithoutLogin()
        .then((oResponse) => {
          console.log("oResponse", oResponse?.data?.data);
          setLogo(oResponse.data.data);
          //setSingleSelectValue({...singleSelectValue, [id]:dropDownOPtions(oResponse.data.data.prescreen_fields)})
        })
        .catch((err) => err);
    }
  };
  useEffect(() => {
    getLogo();
  }, []);

  return (
    <div className="flex w-full flex-col md:flex-row lg:flex-row  pb-10 md:pb-0">
      {/* Left Section*/}
      {/* <section className="flex flex-col md:flex w-full md:w-[40%] justify-center items-center p-6 md:p-8 bg-gradient-to-b from-[#F9FFF3] to-[#F9FFF3]">
        <div className="relative top-4 left-16 w-[70%] sm:w-[40%] md:w-[50%] mb-2 md:mb-24 lg:mb-24">
          <img
            src={logo?.company_logo}
            alt="companylogo"
            className="w-14"
          />
        </div>


        <img
          src={layerimage}
          alt="Illustration"
          className="w-3/4 max-w-xs md:max-w-lg mb-6 md:mb-0"
        />
                <div className="text-center md:text-left mt-4 md:mt-8">
          <p className="text-xl md:text-2xl font-bold text-[#00175e]">
            Land your Dream Job
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-[#00175e] mt-2 md:mt-3">
            Book Your AI Interview
          </h2>
        </div>
      </section> */}
      <section className="w-full md:w-[60%] flex flex-col px-8 gap-2 bg-white">
        {/* <div className="flex items-center justify-end gap-2 ml-4 md:gap-4 mt-2">
          <p className="text-sm text-gray-600 md:text-base">
            Do you have an account?
          </p>
          <Link
            to="/login"
            className="border border-blue-500 text-sm md:text-base px-3 md:px-5 py-1.5 md:py-2 rounded-md hover:text-white hover:bg-[#0071DC] transition duration-300 text-center mr-5 md:mr-0"
          >
            Sign In
          </Link>
        </div> */}
        <p
          className="flex items-center gap-2 cursor-pointer font-medium"
          onClick={() => navigate("/")}
        >
          <IoArrowBackSharp />
          Back
        </p>
        <div className="pageContent scrollbar-hide chart_div flex items-start mt-6 md:mt-0">
          {/* <div className="w-full chart_div"> */}
          {isSignup && isProgress ? (
            <div className="pt-60 pb-60 h-30 w-40">
              <Spin tip="Uploading Please Wait" size="small">
                <div className="content" />
              </Spin>
            </div>
          ) : (
            isSignup && (
              <div className="w-[100%] md-w-[90%] md:w-[75%] flex flex-col gap-4 md:gap-10 ">
                <div className=" px-6 md:px-14 mt-6 md:mt-0 sm:mt-0">
                  <p className="text-3xl md:text-5xl font-semibold ">Sign Up</p>

                  <div className="mt-10 md:mt-10 w-full md:w-[75%] ">
                    <Dragger {...props} showUploadList={true}>
                      <div className="mb-6 chart_div mx-auto mt-3 md:mt-6 p-1">
                        <div>
                          <img
                            src={uploadIcon}
                            alt="uploadIcon"
                            className="w-[30px] h-[30px]"
                          />
                        </div>
                      </div>
                      <p className="pt-2 text-base font-semibold">
                        Upload or drag and drop resume file here
                      </p>
                      <p className="text-8 pb-4">
                        Max file size: 10MB (PDF, Doc, Png )
                      </p>
                    </Dragger>
                  </div>

                  <div className="pt-8">
                    <div
                      className={`flex items-center gap-2 mb-4 ${
                        selectedFile
                          ? "cursor-pointer"
                          : "cursor-not-allowed opacity-50"
                      }`}
                      onClick={() => selectedFile && setIsTermsModalOpen(true)}
                    >
                      <Checkbox
                        checked={isTermsAccepted}
                        disabled={!selectedFile}
                        className="rounded-checkbox"
                        style={{ pointerEvents: "none" }}
                      />
                      <span className="text-[#0071DC] font-semibold">
                        Terms and Condition
                      </span>
                    </div>
                    <style>{`
                        .rounded-checkbox .ant-checkbox-inner {
                          border-radius: 50% !important;
                          border-color: #0071DC !important;
                        }
                        .rounded-checkbox .ant-checkbox-checked .ant-checkbox-inner {
                          background-color: #0071DC !important;
                          border-color: #0071DC !important;
                        }
                     `}</style>
                    <button
                      className={`bg-[#0071DC] text-white font-bold px-10 h-[46px] rounded-lg ${
                        !isTermsAccepted ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                      type="button"
                      onClick={() => handleSignup()}
                      disabled={!isTermsAccepted}
                    >
                      Continue
                    </button>
                  </div>
                </div>
                <div className="w-[100%] md:w-[85%] lg:w-[85%] px-[3rem]">
                  <hr
                    style={{
                      width: "100%",
                      border: "none",
                      borderTop: "1px solid #B8B8B8",
                      margin: 0,
                    }}
                  />
                  <div className="flex items-center gap-3 mt-4">
                    <p className="text-[#000] font-sans">
                      Do you have an account?
                    </p>
                    {/* <span className="text-[#0071DC] font-sans text-lg font-semibold cursor-pointer">
                            Sign Up Now
                          </span> */}
                    <Link
                      to="/login"
                      className="text-[#0071DC] font-sans text-lg font-semibold cursor-pointer"
                    >
                      Sign In
                    </Link>
                  </div>
                </div>
              </div>
            )
          )}
          {/* </div> */}

          {isConfirm && (
            <ProfileConfrmation
              extractedDetails={extractedDetails}
              selectedFile={selectedFile}
              setIsConfirm={setIsConfirm}
              isConfirm={isConfirm}
              setIsVerifyOtp={setIsVerifyOtp}
            />
          )}
          {isVerifyOtp && (
            <OtpVerification
              setIsVerifyOtp={setIsVerifyOtp}
              setIsConfirm={setIsConfirm}
            />
          )}
        </div>
      </section>

      {/* Right Section */}

      <section
        className="relative flex flex-col md:flex  md:w-[40%] md:h-screen h-full justify-center  items-center p-6 md:p-8"
        style={{
          background: "#F3FCF4",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Top Left Concentrated Blue */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "270px",
            height: "270px",
            borderRadius: "270px",
            background: "#0071DC",
            filter: "blur(130px)",
            opacity: 0.7,
            zIndex: 1,
          }}
        />
        {/* Bottom Left Concentrated Blue */}
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "270px",
            height: "270px",
            borderRadius: "270px",
            background: "#0071DC",
            filter: "blur(130px)",
            opacity: 0.7,
            zIndex: 1,
          }}
        />
        {/* Text Content */}
        <div className="text-center md:text-left mt-4 md:mt-12">
          <p className="text-xl md:text-2xl font-bold text-[#00175e] mb-4">
            Elevate your career in three simple steps:
          </p>

          <div className="text-lg md:text-xl text-[#00175e] space-y-1">
            <p>Master Your Interview with expert preparation</p>
            <p>Refine your performance with a data-driven AI Personal Check</p>
            <p>Find Your Job from our curated listings.</p>
          </div>

          <p className="text-xl md:text-2xl font-bold text-[#00175e] mt-4">
            Your path from preparation to placement starts here.
          </p>
        </div>

        <div className="">
          <img
            src={layerimage}
            alt="Illustration"
            className="w-4/4 max-w-xs md:max-w-lg mb-6 md:mb-0 "
          />
        </div>
      </section>
      <Modal
        title="Terms and Conditions"
        open={isTermsModalOpen}
        onCancel={() => setIsTermsModalOpen(false)}
        footer={[
          <Button
            key="accept"
            type="primary"
            onClick={handleAcceptTerms}
            className="bg-[#0071DC]"
          >
            Accept
          </Button>,
        ]}
        width={800}
        centered
      >
        <div className="h-[60vh] overflow-y-auto">
          <FileViewer
            fileType="docx"
            filePath={termsDoc}
            onError={(e) => console.error("Error displaying file:", e)}
          />
        </div>
      </Modal>
    </div>
  );

  // <div className="flex w-full h-screen">
  //   {/* Left Section */}
  //   <div className="w-[40%] background: linear-gradient(180deg, #F9FFF3 0%, #F9FFF3 100%); flex flex-col justify-center items-center p-8">

  //     <img
  //       src={layerimage}
  //       alt="Illustration"
  //       className="w-3/4 max-w-md"
  //     />

  //     {/* Tagline */}
  //     <div className="mt-8 ">
  //       <p className="text-2xl font-bold text-[#00175e]">
  //         Land your Dream Job
  //       </p>
  //       <h2 className="text-4xl font-bold text-[#00175e] mt-3">
  //         Book Your AI Interview
  //       </h2>
  //     </div>
  //   </div>

  //   {/* Right Section */}
  //   <div className="w-[60%] flex flex-col  bg-white px-8">

  //     <div className="w-full flex justify-end gap-4  p-6">
  //       <p className="text-gray-600 text-md mr-14">
  //         Do you have an account?{" "}
  //         <button className="border border-blue-500 text-blue-500 px-4 py-1 rounded-md hover:text-white hover:bg-[#0071DC] transition ml-4 duration-300" >
  //           Sign In
  //         </button>
  //       </p>
  //     </div>

  //     <div className="pageContent scrollbar-hide ">
  //       <div className="w-full flex items-center justify-center ">
  //         {/* <div className="2xl:w-2/6 xl:w-3/6 lg:4/6 md:w-4/6 w-full sm:mx-6 xs:mx-8 rounded-xl bg-white mt-20 mb-20 bg-red-300"> */}
  //         <div className="w-[75%] mt-24">
  //           {isSignup && isProgress ? (
  //             <div className="pt-60 pb-60">
  //               <Spin tip="Uploading Please Wait" size="small">
  //                 <div className="content" />
  //               </Spin>
  //             </div>
  //           ) : (
  //             isSignup && (
  //               <div className="mt-10 px-20 pb-10 ">
  //                 <p className="text-5xl font-semibold">Sign Up</p>
  //                 {/* <p className="text-gray-500 text-base font-semibold mt-4">
  //               Signing up is easy. It only need to upload your resume
  //             </p> */}
  //                 <div className="mt-20 w-[75%] " >
  //                   <Dragger
  //                     {...props}
  //                     showUploadList={true}
  //                   //  defaultFileList
  //                   //\.ant-upload-drag
  //                   >
  //                     <div className="mb-6 chart_div mx-auto mt-8 p-1 ">
  //                       <div>
  //                         <img src={uploadIcon} alt="uploadIcon" className="w-[30px] h-[30px]" />
  //                       </div>
  //                     </div>
  //                     <p className="pt-2 text-base font-semibold">
  //                       Upload or drag and drop resume file here
  //                     </p>
  //                     <p className="text-8 pb-4">
  //                       Max, file size: 10MB (PDF, Doc, Png )
  //                     </p>
  //                   </Dragger>
  //                 </div>
  //                 <div className="pt-12">
  //                   <button
  //                     className="bg-[#0071DC] text-white font-bold px-10  h-[46px] rounded-lg"
  //                     type="button"
  //                     onClick={() => handleSignup()}
  //                   >
  //                     Sign Up
  //                   </button>{" "}
  //                 </div>
  //                 {/* <div className="flex items-center justify-center mt-20">
  //               <p className="text-xl text-[#748396]">
  //                 Do you have an account?
  //               </p>
  //               <Link
  //                 to="/login"
  //                 className="text-xl text-[#0073E6]"
  //                 //onClick={handleClick}
  //               >
  //                 LogIn
  //               </Link>
  //             </div> */}
  //               </div>
  //             )
  //           )}
  //         </div>
  //       </div>

  //       {isConfirm && (
  //         <ProfileConfrmation
  //           extractedDetails={extractedDetails}
  //           selectedFile={selectedFile}
  //           setIsConfirm={setIsConfirm}
  //           isConfirm={isConfirm}
  //           setIsVerifyOtp={setIsVerifyOtp}
  //         />
  //       )}
  //       {isVerifyOtp && (
  //         <OtpVerification
  //           setIsVerifyOtp={setIsVerifyOtp}
  //           setIsConfirm={setIsConfirm}
  //         //setSignUp={Set}
  //         />
  //       )}
  //     </div>

  //   </div>
  // </div>

  // return (
  // <div className="pageContent scrollbar-hide">
  //   <div className="mt-6">
  //     <div className="flex flex-wrap justify-center">
  //       <form
  //         className="pt-5 px-20 pb-20 lg:w-3/4 xl:w-3/4 2xl:w-1/2 sm:w-full "
  //         onSubmit={handleSubmit(onSubmit)}
  //       >
  //         <div className="">
  //           <p className="text-lg font-semibold">Sign Up</p>
  //           <p className="pt-1 text-gray-600 text-base font-normal">
  //             Signing up is easy. It only takes a few steps
  //           </p>
  //         </div>

  //         <div class="flex -mx-2 md:flex-row flex-col mt-8">
  //           <div className="md:w-1/2 w-full px-2">
  //             <Input
  //               type="text"
  //               name="first_name"
  //               label="First Name * "
  //               control={control}
  //               rules={{
  //                 required: "This field is required",
  //               }}
  //               placeholder="Enter your first name"
  //               // className="h-12"
  //             />
  //           </div>
  //           <div className="md:w-1/2 w-full px-2">
  //             <Input
  //               type="text"
  //               name="last_name"
  //               label=" Last Name*"
  //               control={control}
  //               rules={{
  //                 required: "This field is required",
  //               }}
  //               placeholder="Enter your last name"
  //               // className="h-12"
  //             />
  //           </div>
  //         </div>
  //         <div class="flex -mx-2 md:flex-row flex-col">
  //           <div className="md:w-1/2 sm:w-full px-2">
  //             <Input
  //               name="email"
  //               label="Email * "
  //               control={control}
  //               rules={{
  //                 required: "This field is required",
  //               }}
  //               placeholder="Enter your email"
  //             />
  //           </div>

  //           {/* name="mobile_number"
  //                     label=" Phone Number *" */}
  //           <div className="md:w-1/2 w-full px-2">
  //             <div style={{ display: "flex" }}>
  //               {isCountryLayout && (
  //                 <span
  //                   style={{
  //                     width: "10%",
  //                     paddingLeft: "5px",
  //                     paddingTop: "5px",
  //                     marginTop: "36px",
  //                     paddingRight: "45px",
  //                   }}
  //                 >
  //                   <PhoneInput
  //                     country="In"
  //                     value="91"
  //                     inputStyle={{
  //                       height: "35px",
  //                       width: "2%",
  //                       paddingLeft: "0px",
  //                     }}
  //                     onChange={(e) => handelChangePhone(e)}
  //                   />
  //                 </span>
  //               )}
  //               <div className="w-full ">
  //                 <Input
  //                   name="mobile_number"
  //                   label="Phone Number *"
  //                   control={control}
  //                   placeholder="Enter your phone number"
  //                   rules={{
  //                     required: "This field is required",
  //                     // pattern: {
  //                     //   value: /^[0-9]+$/,
  //                     //   message: "only numeric values are allowed",
  //                     // },
  //                   }}
  //                   onChange={handelInputChange}
  //                 />
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //         <div class="flex -mx-2 md:flex-row flex-col">
  //           <div className="md:w-1/2 w-full px-2">
  //             <Input
  //               name="application_username"
  //               label="UserName* "
  //               control={control}
  //               rules={{
  //                 required: "This field is required",
  //               }}
  //               placeholder="Enter your username"
  //               // className="h-12"
  //             />
  //           </div>
  //           <div className="md:w-1/2 w-full px-2">
  //             <Input
  //               name="password"
  //               label="Password*"
  //               control={control}
  //               rules={{
  //                 required: "This field is required",
  //               }}
  //               placeholder="Enter your password"
  //               type="password"
  //             />
  //           </div>
  //         </div>
  {
    /* <div class="flex -mx-2 md:flex-row flex-col">
              <div className="md:w-1/2 w-full px-2">
                <div className="">
                  <DatePicker
                    label="DOB "
                    name={"dob"}
                    noTextInput
                    showToday
                    control={control}
                    placeholder="Select"
                    disableFutureDays={true}
                  />
                </div>
              </div>
              <div className="md:w-1/2 w-full px-2">
                <Input
                  name="total_exp"
                  label="Total Experience *"
                  control={control}
                  rules={{
                    required: "This field is required",
                  }}
                  placeholder="Enter your total experience in years"
                  type="number"
                />
              </div>
            </div> */
  }
  {
    /* <div class="flex -mx-2 md:flex-row flex-col">
              <div className="md:w-1/2 w-full px-2">
                <Input
                  name="current_ctc"
                  label="Current CTC*"
                  control={control}
                  rules={{
                    required: "This field is required",
                  }}
                  placeholder="Eg. 4,50,000 Per Year"
                  type="number"
                />
              </div>
              <div className="md:w-1/2 w-full px-2">
                <Input
                  name="notice_period"
                  label=" Notice Period(in days) *"
                  control={control}
                  rules={{
                    required: "This field is required",
                  }}
                  placeholder="Enter your notice period in days"
                  type="number"
                />
              </div>
            </div>
            <div class="flex -mx-2 md:flex-row flex-col">
              <div className="md:w-1/2 w-full px-2">
                <Select
                  onSearch={(value) => handleSkillSearch(value)}
                  name="skills"
                  placeholder="Search Skills"
                  label="Skills *"
                  control={control}
                  options={skillData?.results?.map((oOption) => {
                    return {
                      value: oOption.option_id,
                      label: oOption.skill,
                    };
                  })}
                  mode="multiple"
                  showSearch
                  rules={{
                    required: "This field is required",
                  }}
                />
              </div>
              <div className="md:w-1/2 w-full px-2">
                <Input
                  name="code"
                  label="Other Skills "
                  control={control}
                  placeholder="Enter your other Skills"
                />
              </div>
            </div>
            <div class="flex -mx-2 md:flex-row flex-col">
              <div className="md:w-1/2 w-full px-2">
                <Select
                  onSearch={(value) => handleEducationsearch(value)}
                  name="qualifications"
                  placeholder="Search Education"
                  label="Education List *"
                  control={control}
                  options={educationData?.results?.map((oOption) => {
                    return {
                      value: oOption.option_id,
                      label: oOption.qualification,
                    };
                  })}
                  mode="multiple"
                  showSearch
                  rules={{
                    required: "This field is required",
                  }}
                />
              </div>
              <div className="md:w-1/2 w-full px-2">
                <Select
                  onSearch={(value) => handleLocations(value)}
                  name="locations"
                  placeholder="Search your current location"
                  label="Current Location *"
                  control={control}
                  options={locations?.results?.map((oOption) => {
                    return {
                      value: oOption.full_city,
                      label: oOption.full_city,
                    };
                  })}
                  showSearch
                  rules={{
                    required: "This field is required",
                  }}
                />
              </div>
            </div> */
  }
  {
    /* <div class="flex -mx-2 md:flex-row flex-col">
              <div className="w-full ">
                <TextArea
                  name="comments"
                  label="Remarks "
                  control={control}
                  className=""
                  placeholder="Enter remarks"
                />
              </div>
            </div> */
  }
  {
    /* <div className="flex">
              <div className="mt-6">
                <div className="">
                  <button
                    type="button"
                    className="rounded-2xl bg-black text-white p-2 text-base"
                    onClick={handleClick}
                  >
                    Upload Resume
                  </button>
                  <input
                    type="file"
                    name="resumes"
                    // {...register('resume', {
                    //     required: "This field is required",
                    // })
                    // }
                    //  {...otherLogoFieldItems}
                    //control={control}
                    onChange={handleFile}
                    ref={hiddenFileInput}
                    accept=".doc, .docx, .pdf, .rtf"
                    style={{ display: "none" }} // Make the file input element invisible
                  />
                </div>
              </div>
              {isActiveFile && (
                <div className="flex flex-wrap  mt-6 mx-4">
                  <p className="text-body3 mt-3 px-2">
                    {fileName ? fileName?.name : ""}
                  </p>
                </div>
              )}
              <p className="text-body3 ml-4 mt-8">
                DOC, DOCx, PDF, RTF | Max: 2 MB
              </p>
            </div> */
  }
  {
    /* <div className="mt-14 flex items-center justify-center">
              <button
                className="bg-[#FF4544] text-white w-1/2 rounded-md h-[42px]"
                type="submit"
              >
                Sign Up
              </button>
            </div>
          </form>
          {open && <CandidateLogin open={open} onClose={onClose} />}
        </div>
      </div>
      <div>
        <img src={groupIcon} alt="icons" />
      </div>
      <div>
        <FooterLayout />
      </div>
    </div> */
  }
  {
    /* ); */
  }
};
export default CandidateRegister;
